import React, { useEffect, useRef } from 'react';

import Spinner from '../../UI/Spinner';
import WowzaVideoJsPlayer from './WowzaVideoJsPlayer';

import './WowzaPlayer.css';

const WowzaPlayerContainer = (props) => {
  const componentRef = useRef();
  const source = props.media?.wowza?.hls_url;
  const hlsUrl = typeof source === 'string' ? source.trim() : '';

  useEffect(() => {
    if (typeof props.getHeight !== 'function') return undefined;

    const reportHeight = () => {
      if (componentRef.current) {
        props.getHeight(componentRef.current.getBoundingClientRect().height);
      }
    };

    reportHeight();
    window.addEventListener('resize', reportHeight);
    return () => window.removeEventListener('resize', reportHeight);
  }, [props.getHeight]);

  return (
    <div ref={componentRef} className='wowzaPlayerContainer'>
      {hlsUrl ? (
        <WowzaVideoJsPlayer
          title={props.title}
          sourceURL={hlsUrl}
          isOnlyVideo={props.isOnlyVideo}
          preview={props.preview}
          liveStarted={props.event?.liveStarted}
          qnaMode={props.qnaMode}
        />
      ) : (
        <div className='wowzaPlayerSpinner'>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default React.memo(WowzaPlayerContainer);
